// src/cmps/comment/CommentList.jsx
import { buildCommentTree } from '../../services/CommentSystem/buildCommentTree'
import { CommentPreview } from './CommentPreview'

export function CommentList({
  comments = [],
  users = [],
  loggedInUser,
  onAddComment,
  onEditComment,
  onRemoveComment,
  onToggleLike,
}) {
  if (!comments.length) {
    return <p className="text-red-500">אין תגובות עדיין.</p>
  }

  // בניית עץ התגובות כך שנוכל להציגן בצורה מקוננת
  const nestedComments = buildCommentTree(comments)

  // מציאת התגובה המובילה מבין תגובות רמה 0 (root-level)
  const topComment = nestedComments.reduce((acc, curr) => {
    const currLikes = curr.likes ? curr.likes.length : 0
    const accLikes = acc && acc.likes ? acc.likes.length : 0
    return currLikes > accLikes ? curr : acc
  }, null)

  // סינון התגובות האחרות (לא כולל התגובה המובילה)
  const otherComments = nestedComments.filter(
    (comment) => comment._id !== topComment?._id
  )

  return (
    <div className="">
      {/* הצגת התגובה המובילה, אם קיימת */}
      {topComment && (
        <CommentPreview
          key={topComment._id}
          comment={topComment}
          users={users}
          loggedInUser={loggedInUser}
          onAddComment={onAddComment}
          onEditComment={onEditComment}
          onRemoveComment={onRemoveComment}
          onToggleLike={onToggleLike}
          depth={0}
          maxDepth={3}
          // מעבירים prop שמסמן שמדובר בתגובה מובילה
          isTopComment={true}
        />
      )}

      {/* הצגת שאר התגובות (שאינן מובילות) */}
      {otherComments.map((comment) => (
        <CommentPreview
          key={comment._id}
          comment={comment}
          users={users}
          loggedInUser={loggedInUser}
          onAddComment={onAddComment}
          onEditComment={onEditComment}
          onRemoveComment={onRemoveComment}
          onToggleLike={onToggleLike}
          depth={0}
          maxDepth={3}
          isTopComment={false}
        />
      ))}
    </div>
  )
}
